export default __webpack_public_path__ + "static/media/japan.b9821b88.geojson";